import { z } from 'zod';
import { esquemaMotivo } from './comunes.js';
/**
 * Cobro por adaptador (F5.2, BILL-02, plan maestro §11.6, AC-15).
 *
 * - Un evento del proveedor no se cree hasta verificar su firma.
 * - `providerEventId` es unico por proveedor: un duplicado no cobra dos veces.
 * - Los eventos llegan tarde y en desorden: cada uno trae cuando OCURRIO, y uno
 *   mas viejo que el ultimo aplicado se guarda pero no cambia nada.
 * - Una redireccion del navegador despues de pagar no activa nada: solo el
 *   evento verificado o la conciliacion.
 * - Un pago manual lleva importe, moneda, referencia, fecha, evidencia y la
 *   aprobacion de OTRA persona.
 */
export const TIPOS_DE_EVENTO_DE_PAGO = [
    'pago.confirmado',
    'pago.fallido',
    'suscripcion.cancelada',
];
export const ESTADOS_DE_EVENTO_DE_PAGO = [
    'aplicado',
    /** Llego despues de otro mas reciente: se guarda, no cambia nada. */
    'antiguo',
    /** La referencia no corresponde a ninguna suscripcion vinculada. */
    'sin-suscripcion',
    /**
     * Pago confirmado con otra moneda o por menos del precio del plan (§14.1, ADR-011):
     * no activa nada; el pago queda pendiente de que una persona lo revise.
     */
    'monto-inesperado',
];
/** Lo que un adaptador entrega ya verificado y normalizado. */
export const esquemaEventoDeProveedor = z
    .object({
    id: z.string().trim().min(1).max(200),
    tipo: z.enum(TIPOS_DE_EVENTO_DE_PAGO),
    /** La referencia que la plataforma dio al vincular: `<organizacionId>.<aleatorio>`. */
    referencia: z.string().trim().min(1).max(200),
    ocurrioEn: z.coerce.date(),
    importeCentavos: z.number().int().min(0).nullable().default(null),
    moneda: z
        .string()
        .regex(/^[A-Z]{3}$/)
        .nullable()
        .default(null),
    /** Hasta cuando cubre lo pagado (o hasta cuando sigue vigente lo cancelado). */
    periodoHasta: z.coerce.date().nullable().default(null),
})
    .strict();
export const esquemaPagoManual = z
    .object({
    importeCentavos: z.number().int().min(1),
    moneda: z.string().regex(/^[A-Z]{3}$/),
    referencia: z.string().trim().min(3).max(120),
    fecha: z.coerce.date(),
    /** Que respalda el pago: folio de transferencia, recibo. Sin datos bancarios completos. */
    evidencia: z.string().trim().min(5).max(500),
    periodoHasta: z.coerce.date(),
    motivo: esquemaMotivo,
})
    .strict();
export const ORIGENES_DE_PAGO = ['proveedor', 'manual'];
export const ESTADOS_DE_PAGO = ['confirmado', 'pendiente-aprobacion', 'rechazado'];
//# sourceMappingURL=pagos.js.map